import { useSyncExternalStore } from "react";

/**
 * Which kind of roster board is open right now, if any.
 *
 * The Guided tours list is opened from the sidebar, outside the board's layout, and it only knows
 * the pathname. A recruiting board and a roster board share the same routes but run different
 * tours on their Players tab, so the board layout publishes its kind here and the list reads it to
 * offer only the tours that board actually runs.
 */
export type RosterBoardKind = "recruiting" | "roster";

let current: RosterBoardKind | null = null;
const listeners = new Set<() => void>();

export const setActiveRosterBoardKind = (kind: RosterBoardKind | null): void => {
  if (kind === current) return;
  current = kind;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const snapshot = () => current;

/** The current value, outside React (tests, and anything that only needs to read it once). */
export const getActiveRosterBoardKind = (): RosterBoardKind | null => current;

/** The open board's kind, or null when no board is open (or it has not loaded yet). */
export const useActiveRosterBoardKind = (): RosterBoardKind | null =>
  useSyncExternalStore(subscribe, snapshot, snapshot);
